import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './style.css';


/**
 * Creates the article links for the `In this Issue` content
 */
const Article = props => <a href={ props.url } className="article" dangerouslySetInnerHTML={{ __html: props.title }} />;

/**
 * Displays the `In This Issue` content for the modal
 */
const InThisIssue = props => {
    if( !props.articles ) return null;
    return (
        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
            <h2 className="inthisstyle">{ props.label }</h2>
            { props.articles.map( ( article, index ) => <Article { ...article } key={ `article-${ index }` } /> ) }
        </div>
    )
}


/**
 * @name Details
 * @function
 * @description Displays Details
 * @returns {JSX}
 * @param {*} props 
 */
function Details( props ){
   
    return (
        <Modal className="archives details" bssize="large" show={props.visible} onHide={props.onClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title className="header">
                {props.labels.Volume} { props.publication.volume }&nbsp;
                <span>
                    {props.labels.Number}{ props.publication.number }
                </span>
              </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <img src={ props.publication.imageUrl } alt={ props.publication.imageUrl}/>
                    <a href={ props.publication.pdfUrl } className="download"><i className="fas fa-download" ></i> { props.labels.Download }</a>
                </div>
                <InThisIssue label={ props.labels[ 'InThisIssue-Label' ] } articles={ props.publication.articles } />
            </div>
        </Modal.Body>
      </Modal>
    ); 
}

Details.defaultProps = {
    visible: false
};

Details.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose:  PropTypes.func.isRequired,
    publication:  PropTypes.shape({
        volume: PropTypes.number,
        imageUrl: PropTypes.string,
        pdfUrl: PropTypes.string,
        publishDate: PropTypes.instanceOf(Date),
        number: PropTypes.number,
        articles: PropTypes.array
    }),
    labels: PropTypes.object.isRequired
}

export default Details;
